import Axios from 'axios';

class FeeClosingsService {
  getMonth(month) {
    return Axios.get('/admin/fee-closings', { params: { month } })
      .then(({ data }) => data);
  }

  generate(month) {
    return Axios.post('/admin/fee-closings', { month })
      .then(({ data }) => data);
  }

  get(id) {
    return Axios.get(`/admin/fee-closings/${id}`)
      .then(({ data }) => data);
  }

  previewEmissions(month) {
    return Axios.get('/admin/fee-closings/emissions/preview', { params: { month } })
      .then(({ data }) => data);
  }

  emitMonth(month) {
    return Axios.post('/admin/fee-closings/emissions', null, { params: { month } })
      .then(({ data }) => data);
  }

  emitClosing(id) {
    return Axios.post(`/admin/fee-closings/${id}/emission`)
      .then(({ data }) => data);
  }

  retryEmission(id) {
    return Axios.post(`/admin/fee-closings/${id}/emission/retry`)
      .then(({ data }) => data);
  }
}

export default new FeeClosingsService();
